import { useAssessment } from '../../context/AssessmentContext'
import Shell from '../ui/Shell'
import AnswerRows from '../ui/AnswerRows'
import { AREA_BY_SLUG, buildScreener, HEADERS } from '../../data/onboarding'
import { getProgress, STEP_LABEL } from '../../lib/flow'

/**
 * The six-question screener, asked for the PRIMARY area only and only when it
 * is currently in use — the production rule (CH03-L-PRIMARY-ONLY-SCREENER).
 */
function ScreenerStep() {
  const { state, dispatch } = useAssessment()
  const slug = state.primaryAddiction
  const area = AREA_BY_SLUG[slug]
  const questions = slug ? buildScreener(slug) : []
  const index = state.currentScreenerIndex
  const question = questions[index]

  if (!question) {
    dispatch({ type: 'SET_SCREEN', payload: 'addictionSelection' })
    return null
  }

  const answer = (option) => {
    dispatch({ type: 'ANSWER_SCREENER', payload: { index, option } })
    if (index < questions.length - 1) dispatch({ type: 'NEXT_SCREENER' })
    else dispatch({ type: 'SET_SCREEN', payload: 'dassAssessment' })
  }

  const back = () => {
    if (index > 0) dispatch({ type: 'PREV_SCREENER' })
    else if (state.selectedAddictions.length > 1) dispatch({ type: 'SET_SCREEN', payload: 'prioritization' })
    else {
      dispatch({ type: 'SET_AREA_INDEX', payload: 0 })
      dispatch({ type: 'SET_SCREEN', payload: 'recoveryGate' })
    }
  }

  return (
    <Shell label={STEP_LABEL.screener} progress={getProgress(state)} onBack={back}>
      <main className="flow">
        <div className="q" key={index}>
          <div className="q__meta">
            <span>{index + 1} of {questions.length}</span>
            <span>{area?.label}</span>
          </div>
          <div className="q__body">
            <p className="q__frame">{HEADERS.screener}</p>
            <h1 className="q__text" style={{ marginTop: 8 }}>{question.question}</h1>
          </div>
          <div className="q__body" style={{ animationDelay: '40ms' }}>
            <AnswerRows
              options={question.answers.map((a) => ({ title: a.text }))}
              value={state.screenerAnswers[index] ?? null}
              onChoose={answer}
            />
          </div>
        </div>
      </main>
    </Shell>
  )
}

export default ScreenerStep
